module.exports = __webpack_public_path__ + "static/media/IMG_7289_DxO.3840d224.jpg";